import { captureError } from '@smg-real-estate/browser-rum';

import { get } from '@/api/fetch';
import { type Invoice } from '@/types';

export async function getUserInvoices(personId: string): Promise<Invoice[]> {
  const invoicesUrl = `${import.meta.env.VUE_APP_INSERTION_FUNNEL_API_BASE_URL}/users/${personId}/invoices`;
  try {
    const resp = await get(invoicesUrl);
    const data = await resp.json();
    return data?.data?.items || [];
  } catch (error) {
    captureError(error, {
      service: 'invoices-api',
      action: 'get-invoices',
      personId,
      invoicesUrl,
    });
    throw error;
  }
}
